<template>

</template>

<script>
export default {
  name: "bsqCgq"
}
</script>

<style scoped>

</style>
